let coll = document.getElementsByClassName("collapsible");

for (let i = 0; i < coll.length; i++) {
	if (Array.from(coll[i].classList).indexOf("navbar__link") !== -1) {
		coll[i].addEventListener("mouseover", function () {
			if (Array.from(this.classList).indexOf("active") !== -1) {
				hideAll();
			} else {
				hideAll();
				this.classList.toggle("active");
				var content = this.nextElementSibling;
				content.addEventListener("mouseover", function(){
					clearTimeout(navTimer);
				});
				content.addEventListener("mouseleave", function(){
					navTimer = setTimeout(() => hideAll(), 500);
				})
				if (content.style.display === "block") {
					content.style.display = "none";
				} else {
					content.style.display = "block";
				}
			}
		});
		coll[i].addEventListener("mouseleave", function () {
			navTimer = setTimeout(() => hideAll(), 3000);
		});
	}
	coll[i].addEventListener("click", function () {
		if (Array.from(this.classList).indexOf("active") !== -1) {
			hideAll();
		} else {
			hideAll();
			this.classList.toggle("active");
			var content = this.nextElementSibling;
			if (content.style.display === "block") {
				content.style.display = "none";
			} else {
				content.style.display = "block";
			}
		}
	});
}
